import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("wiqx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401) {
      const path = window.location.pathname;
      if (!path.startsWith("/login") && !path.startsWith("/pay") && !path.startsWith("/signup") && path !== "/" && !path.startsWith("/pricing") && !path.startsWith("/forgot")) {
        localStorage.removeItem("wiqx_token");
      }
    }
    return Promise.reject(err);
  }
);

export default api;
